import { AppItemMock } from '@components';

const { image, ...AppItem } = AppItemMock;

export const AppItemsMock = [
	AppItem,
	{ ...AppItem, id: 2 },
	{ ...AppItem, id: 3 },
];
